<template>
  <div class="d-flex justify-content-between">
    <!--    <div class="nav-disabled" />-->
    <div class="card-body2">
      <div class="header-wizard" />
      <div class="body-wizard">
        <h3>Начало работы</h3>
        <hr>
        <h3 style="width: 800px">
          Здорово! Все готово - самое время расклеить объявления для жильцов и положить им приглашения в почтовые ящики!
        </h3>
        <div class="d-flex justify-content-start mt-4">
          <b-button class="mr-3" variant="outline-primary" :href="getPrintNotificationHouse" target="_blank">
            Распечатать объявления для жителей
          </b-button>
          <b-button class="mr-5" variant="outline-primary" :href="getPrintNotificationsPersonalAccount" target="_blank">
            Распечатать поквартирные уведомления
          </b-button>
        </div>
        <b-button class="mr-5 mt-3" variant="primary" @click="startWork">
          Начать работу с программой
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Endpoints } from '@/connectors/endpoints'

export default {
  name: 'EndWizard',
  data () {
    return {
      Endpoints
    }
  },
  computed: {
    getPrintNotificationHouse () {
      return process.env.VUE_APP_BASE_URL + Endpoints.PRINT_NOTIFICATION_HOUSE + '?moid=' + localStorage.getItem('moid') + '&house_id=' + localStorage.getItem('houseId')
    },
    getPrintNotificationsPersonalAccount () {
      return process.env.VUE_APP_BASE_URL + Endpoints.PRINT_NOTIFICATION_PERSONAL_ACCOUNT + '?moid=' + localStorage.getItem('moid') + '&house_id=' + localStorage.getItem('houseId')
    }
  },
  methods: {
    startWork () {
      localStorage.removeItem('houseId')
      localStorage.removeItem('moid')
      localStorage.removeItem('onlyOneHouse')
      localStorage.removeItem('personalAccId')
      this.$router.push('/app/account')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/scss/wizard';
span {
  color: #7c4dff;
}
</style>
